import { render, staticRenderFns } from "./CampoToggle.vue?vue&type=template&id=c4d01ed8"
import script from "./CampoToggle.vue?vue&type=script&lang=js"
export * from "./CampoToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports